import React from "react";
import { Languages, Check } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

const LANGS = [
  { v: "fr", code: "FR", key: "lang.fr" },
  { v: "en", code: "EN", key: "lang.en" },
];

export const LanguageToggle = ({ className }) => {
  const { lang, setLang, t } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-toggle-bouton"
          aria-label={`${t("lang.label")}: ${lang.toUpperCase()}`}
          className={cn("inline-flex items-center gap-1 rounded-full px-2 py-2 text-sm font-semibold text-foreground transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring", className)}
        >
          <Languages className="h-4 w-4" />
          <span className="text-xs">{lang.toUpperCase()}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuLabel>{t("lang.label")}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.v} onClick={() => setLang(l.v)} data-testid={`language-option-${l.v}`} className="gap-2">
            <span className="text-xs font-bold">{l.code}</span> {t(l.key)}
            {lang === l.v && <Check className="ml-auto h-4 w-4 text-secondary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
